import StatusPill from "@/components/ui/status-pill";
import { getAttitudeTone } from "@/lib/attitudeStyles";

/**
 * A buyer's attitude ("Friendly", "Skeptical") as a pill, coloured by its
 * difficulty through getAttitudeTone, so the same attitude is the same colour
 * on the assignment, the result, the simulator and the leaderboard. Renders
 * nothing for an empty attitude.
 */
export default function AttitudePill({ value, size = "sm", className }) {
  if (!value) return null;
  return (
    <StatusPill
      variant="soft"
      size={size}
      tone={getAttitudeTone(value)}
      label={value}
      className={className}
    />
  );
}
